import { type ReduxStateShared } from '~shared/types';

const getModal = (state: ReduxStateShared) => state.modal;

export default getModal;
